// cloudinary.js — uploads an image file directly to Cloudinary (unsigned)
// Needs these in .env.local:
//   REACT_APP_CLOUDINARY_CLOUD_NAME
//   REACT_APP_CLOUDINARY_UPLOAD_PRESET

const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

export async function uploadToCloudinary(file) {
  const data = new FormData();
  data.append("file", file);
  data.append("upload_preset", UPLOAD_PRESET);

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
    { method: "POST", body: data }
  );

  if (!res.ok) {
    const err = await res.text();
    throw new Error("Cloudinary upload failed: " + err);
  }

  const json = await res.json();
  return json.secure_url; // the hosted image URL
}
